import capitalize from 'lodash/capitalize';
import lowerCase from 'lodash/lowerCase';

export const beautifyName = (value, lowerCaseMinors = true) =>
  String(value)
    .split(' ')
    .map(name =>
      name.length >= 3
        ? capitalize(name)
        : lowerCaseMinors
        ? lowerCase(name)
        : name,
    )
    .join(' ');

export const beautifyClinicName = fullName =>
  beautifyName(String(fullName), false);
